import React from 'react';
import {Navigation} from '../../Navigation';
import * as RouterActions from '../../../actions/RouterActions'
import {useDispatch} from 'react-redux';

export const ImagetoolNavigation = function(props){
    const dispatch = useDispatch();

    return (
        <Navigation title="ImageTool" icon="image" breadcrumb={props.breadcrumb} menu={
            [
                {
                    caption: 'Browser',
                    icon: 'grid layout',
                    active: props.active === 'files',
                    onClick: () => dispatch(RouterActions.push('/staticfiles/files/'))
                },
                {
                    caption: 'Zeitplan',
                    icon: 'calendar alternate outline',
                    active: props.active === 'publish',
                    entries: [
                        {
                            caption: 'Desktop',
                            icon: 'desktop',
                            onClick: () => dispatch(RouterActions.push('/staticfiles/publish/app')),
                            href: '/staticfiles/publish/app'
                        },
                        {
                            caption: 'Smartphone App',
                            icon: 'mobile alternate',
                            onClick: () => dispatch(RouterActions.push('/staticfiles/publish/kiosk')),
                            href: '/staticfiles/publish/kiosk'
                        }
                    ]
                }
            ]
        }>
            {props.children}
        </Navigation>
    )
}